<template>
  <div class="d-flex justify-content-between align-items-baseline my-sm-5 my-4">
    <b-skeleton type="button" v-if="status"></b-skeleton>
    <h5 v-else class="text-color-444 weight-bold fontsize-large">{{ text }}</h5>
    <div :class="mode == 'flash' ? 'campaigns-line' : 'line bg-color-c8 w-75'" :style="customStyle"></div>
    <b-skeleton v-if="status" type="button"></b-skeleton>

    <router-link
      v-else
      :to="route"
      class="
          campaigns-more-btn
          py-2
          px-3
          text-light
          text-color-444
          fontsize-small
        "
    >
      {{ textBtn }}
    </router-link>
  </div>
</template>
<script>
import {BSkeletonTable, BSkeleton} from 'bootstrap-vue'

export default {
  components: {
    BSkeletonTable, BSkeleton
  },
  props: {
    status: { Boolean },
    text: { String },
    route: { String },
    textBtn: { String },
    mode: String,
    customStyle: {
      default: '',
      type: String
    }
  },
};
</script>
